import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page"
}
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-4xl mb-3 font-bold tracking-tight text-gray-900" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fa fa-book" }),
    /*#__PURE__*/_createTextVNode(" Courses ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-4 leading-6" }, [
    /*#__PURE__*/_createTextVNode(" Here you can add, delete or edit Courses."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Click on a Course for details. ")
  ])
], -1)
const _hoisted_4 = { class: "page-container" }
const _hoisted_5 = {
  key: 0,
  class: "loading-container mt-4"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = { class: "p-input-icon-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = {
  key: 0,
  class: "fa-solid fa-circle-check text-green-500"
}
const _hoisted_12 = {
  key: 1,
  class: "fa-regular fa-circle-xmark text-red-500"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "line-clamp-3 text-gray-400 text-sm" }
const _hoisted_15 = { class: "whitespace-nowrap" }
const _hoisted_16 = { class: "flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_ctx.hasAccess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ConfirmDialog),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/course/create'))),
              label: "New course",
              icon: "fa fa-plus-circle"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          ($data.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_Loading, { text: "Fetching courses" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_DataTable, {
                  value: _ctx.courses,
                  rows: 10,
                  paginator: "",
                  dataKey: "id",
                  tableStyle: "min-width: 50rem",
                  sortField: "createdAction.timestamp",
                  sortOrder: -1,
                  globalFilterFields: ['title'],
                  filters: $data.filters,
                  "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($data.filters) = $event)),
                  onRowClick: $options.onRowClicked
                }, {
                  empty: _withCtx(() => [
                    _createTextVNode("No courses found.")
                  ]),
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(_component_InputText, {
                          modelValue: $data.filters['global'].value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.filters['global'].value) = $event)),
                          placeholder: "Keyword Search"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "isActive",
                      header: "Active"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_10, [
                          (data.isActive)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11))
                            : (_openBlock(), _createElementBlock("span", _hoisted_12))
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "title",
                      header: "Title",
                      sortable: "",
                      searchable: ""
                    }),
                    _createVNode(_component_Column, {
                      header: "Image",
                      class: "min-w-[148px]"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("img", {
                          src: data.imageUrl,
                          class: "w-32 drop-shadow-xl rounded-md"
                        }, null, 8, _hoisted_13)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "description",
                      header: "Description"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(data.description), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "createdAction.timestamp",
                      header: "Created",
                      dataType: "date",
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$filters.formatDate(data.createdAction?.timestamp)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, null, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_Button, {
                            onClick: _withModifiers(($event: any) => ($options.confirmDuplicate(data)), ["stop","prevent"]),
                            icon: "fa fa-clone",
                            severity: "secondary",
                            rounded: ""
                          }, null, 8, ["onClick"]),
                          (_ctx.canDelete)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                onClick: _withModifiers(($event: any) => ($options.confirmDelete(data)), ["stop","prevent"]),
                                icon: "fa fa-trash",
                                severity: "secondary",
                                rounded: ""
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters", "onRowClick"])
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}